var _tspan;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHeroIconViz2 = function SvgHeroIconViz2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 22
  }, props), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 18)",
    style: {
      fill: "#005dfd",
      fontSize: 20,
      fontFamily: "Georgia-BoldItalic,Georgia",
      fontWeight: 700,
      fontStyle: "italic"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "%"))));
};

export { SvgHeroIconViz2 as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='18' height='22' viewBox='0 0 18 22'%3e%3cdefs%3e%3cstyle%3e.a%7bfill:%23005dfd;font-size:20px;font-family:Georgia-BoldItalic, Georgia;font-weight:700;font-style:italic;%7d%3c/style%3e%3c/defs%3e%3ctext class='a' transform='translate(0 18)'%3e%3ctspan x='0' y='0'%3e%25%3c/tspan%3e%3c/text%3e%3c/svg%3e";